import {
  GET_LIST_CHIDELETE,
  GET_LIST_CHIDELETE_SUCCESS,
  GET_LIST_CHIDELETE_FAILURE,
  UPDATE_SEARCHTDATA_CHIDELETE,
} from "./actionTypes";

export const getListChiDelete = (dataSearch) => ({
  type: GET_LIST_CHIDELETE,
  dataSearch,
});
export const getListChiDeleteSuccess = (data) => ({
  type: GET_LIST_CHIDELETE_SUCCESS,
  payload: data,
});
export const getListChiDeleteFailure = (dataSearch) => ({
  type: GET_LIST_CHIDELETE_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_CHIDELETE,
  payload: data,
});
